import { docReady } from '../helpers/docReady';
import '../../styles/templates/collection.scss';
docReady(() => {
    // console.log('Collection Template JS Ready');
});
